import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_brand",
  ref: "addBrandModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_brand_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Add a Brand", -1)
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_brand_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_brand_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_brand_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group d-flex flex-wrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Status", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-7" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Brand Name", -1)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Brand Short-Key", -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-7" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Seo Title", -1)
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Website", -1)
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "description", -1)
const _hoisted_29 = { class: "row mb-7" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Seo description", -1)
const _hoisted_32 = { class: "modal-footer flex-center" }
const _hoisted_33 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_34 = { class: "indicator-label" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_form_item, { prop: "status" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.formData.status,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
                            "active-value": 10,
                            "inactive-value": 25,
                            prop: "status",
                            class: "ms-5"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_form_item, { prop: "name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
                            type: "text",
                            placeholder: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_el_form_item, { prop: "short_key" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.short_key,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.short_key) = $event)),
                            type: "text",
                            placeholder: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_form_item, { prop: "seo_title" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.seo_title,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.seo_title) = $event)),
                            type: "text"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_el_form_item, { prop: "website" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.website,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.website) = $event)),
                            type: "url"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_el_form_item, { prop: "description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.description,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.description) = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_el_form_item, { prop: "seo_description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.seo_description,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.seo_description) = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, " Discard "),
              _createElementVNode("button", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_37
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}